// extracted by mini-css-extract-plugin
module.exports = {"rowContainer":"DetailFormReadOnly_rowContainer__LyxSH","ICDBlock":"DetailFormReadOnly_ICDBlock__1HtaI"};